a<template>
    <div class="content" sticky-container>
        <div
            class="content-left"
            v-if="$slots.left"
        >
            <slot name="left" />
        </div>
        <div class="content-center">
            <div
                :class="$slots.subtitle ? 'content-header' : 'content-header border-bottom'"
                v-if="!hideHeader"
            >
                <div class="content-header-title">
                    <div v-if="!$slots.title">
                        {{ title }}

                        <rkm-icon
                            v-if="hasAbasComConteudo"
                            @click.native="() => $refs.RkmModal.show()"
                            class="question-icon"
                            icon="question-circle"
                        />
                    </div>
                    <slot v-else name="title" />
                </div>
                <div class="content-header-center" v-if="$slots.center">
                    <slot name="center" />
                </div>
                <div class="content-header-actions" v-if="$slots.actions">
                    <slot name="actions" />
                </div>
            </div>
            <div
                class="content-header-sub"
                v-if="$slots.subtitle"
            >
                <div class="content-header-title">
                    <slot name="subtitle" />
                </div>
            </div>
            <div class="content-body">
                <slot />
            </div>
        </div>
        <div
            class="content-right"
            v-if="$slots.right"
        >
            <slot name="right" />
        </div>

        <rkm-modal
            v-if="hasAbasComConteudo"
            :buttons="['cancel']"
            extra-large
            title="Manual da funcionalidade"
            ref="RkmModal"
        >
            <rkm-tabs>
                <rkm-tab
                    v-for="(aba, i) in routerInfo.dadosFuncionalidade.abas.filter(a => !!a.texto)"
                    :key="i"
                    :title="aba.nome"
                >
                    <div v-html="aba.texto" class="conteudo-aba"></div>
                </rkm-tab>
            </rkm-tabs>
        </rkm-modal>
    </div>
</template>

<script>
// Others.
import Sticky from 'vue-sticky-directive'

// Vuex.
import { mapGetters } from 'vuex'

export default {
    computed: {
        ...mapGetters({routerInfo: 'getRouterInfo'}),
        hasAbasComConteudo() {
            return !!this.routerInfo
                && this.routerInfo.dadosFuncionalidade.abas.length > 0
                && this.routerInfo.dadosFuncionalidade.abas.some(a => !!a.texto)
        }
    },
    directives: { Sticky },
    props: {
        title: { type: String },
        hideHeader: { type: Boolean, default: false },
    },
    data: () => ({
        stickyEnabled: true,
        offset: { top: 0 },
    })
}
</script>

<style scoped>
.content {
    display: flex;
    flex-wrap: nowrap;
}
.content-header {
    align-items: center;
    background: #FFF;
    display: flex;
    justify-content: space-between;
    overflow: hidden;
    padding: 12px 15px;
}
.content-header > .border-bottom {
    border-bottom: 1px solid #dfdfdf;
}
.content-header-sub {
    align-items: center;
    background: #f3f3f3;
    border-bottom: 1px solid #dfdfdf;
    display: flex;
    justify-content: space-between;
    overflow: hidden;
    padding: 3px 15px;
    box-shadow: -1px 4px 6px -3px rgba(177, 177, 177, 0.55);
    -webkit-box-shadow: -1px 4px 6px -3px rgba(177, 177, 177, 0.55);
    -moz-box-shadow: -1px 4px 6px -3px rgba(177, 177, 177, 0.55);
}

.content-body {
    padding: 15px;
}
.content-header-title {
    font-size: 1.3rem;
    letter-spacing: -0.5px;
    text-transform: uppercase;
}
.content-center {
    flex: 1;
}
.content-left {
    border-right: 1px solid;
}
.content-right {
    border-left: 1px solid;
}
.content-left, .content-right {
    background: #FFF;
    border-color: #ced4da;
    height: calc(100vh - 57px);
    padding: 15px;
}
.btn-actions-pane-right {
    margin: 0 !important;
}
.content-header, .content-right, .content-left {
    position: sticky;
    top: 57px;
    z-index: 997;
}
.content-header-sub {
    position: sticky;
    top: 116px;
    z-index: 996;
}

.question-icon:hover {
    background-color: none;
    cursor: pointer;
}

.conteudo-aba {
    overflow-wrap: anywhere;
}
</style>